import { render, staticRenderFns } from "./productosKits.vue?vue&type=template&id=3a8fddfc&"
import script from "./productosKits.vue?vue&type=script&lang=js&"
export * from "./productosKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports